/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import AppCheckBox from '../../../../shared/components/app-check-box/AppCheckBox';
import { DURATION_BUCKETS } from '../../constants/cruiseConstants';
import {
  durationBucketOf,
  facetCounts,
  nightsOf,
  portLabel,
  titleCase,
} from '../../utils/cruiseUtils';

/** Facet lists are built from the full result set, not the filtered one. */
export const buildFacets = (cruises) => ({
  duration: DURATION_BUCKETS.map((b) => ({
    value: b.key,
    label: b.label,
    count: cruises.filter((c) => durationBucketOf(nightsOf(c)) === b.key)
      .length,
  })).filter((f) => f.count > 0),
  port: facetCounts(cruises, (c) => c.startPortName).map((f) => ({
    ...f,
    label: portLabel(titleCase(f.value)),
  })),
  ship: facetCounts(cruises, (c) => c.shipName).map((f) => ({
    ...f,
    label: f.value,
  })),
  line: facetCounts(cruises, (c) => c.cruiseLineName).map((f) => ({
    ...f,
    label: f.value,
  })),
});

const GROUPS = [
  { key: 'duration', title: 'Duration' },
  { key: 'port', title: 'Departure port' },
  { key: 'ship', title: 'Ship' },
  { key: 'line', title: 'Cruise line' },
];

function CruiseFilters({ facets, filters, onChange, onClear, open, onToggle }) {
  const toggle = (group, value) => {
    const list = filters[group];
    onChange({
      ...filters,
      [group]: list.includes(value)
        ? list.filter((v) => v !== value)
        : [...list, value],
    });
  };

  return (
    <aside className="cr-filters">
      <div className="cr-filters__head">
        <button type="button" className="cr-filters__title" onClick={onToggle}>
          Filters
        </button>
        <button type="button" className="cr-link" onClick={onClear}>
          Clear all
        </button>
      </div>
      {open &&
        GROUPS.filter((g) => facets[g.key]?.length).map((g) => (
          <div className="cr-filters__group" key={g.key}>
            <div className="cr-filters__group-title">{g.title}</div>
            {facets[g.key].map((f) => (
              <AppCheckBox
                key={f.value}
                id={`cr-filter-${g.key}-${f.value}`}
                name={`cr-filter-${g.key}`}
                checked={filters[g.key].includes(f.value)}
                onChange={() => toggle(g.key, f.value)}
                labelClassName="cr-filters__option"
                labelText={
                  <>
                    <span className="cr-filters__label">{f.label}</span>
                    <span className="cr-filters__count">{f.count}</span>
                  </>
                }
              />
            ))}
          </div>
        ))}
    </aside>
  );
}

CruiseFilters.propTypes = {
  facets: PropTypes.object.isRequired,
  filters: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default CruiseFilters;
